import { shallowEqual } from 'react-redux';

import { useSelector } from '../../../../selectors/useSelector';

import MonthlyRentFormField from './MonthlyRentFormField';
import SpecialOffers from '../../SpecialOffers';

import SecurityDepositFormField from '../../SecurityDeposit/components/SecurityDepositFormField';

import accessUtils from '../../../../utils/accessUtils';
import { Box } from '@zillow/constellation-10';
import { WizardBody, WizardFormSectionContainer, WizardHeading } from '../../../../styles/wizard';

const body = `A security deposit isn’t required, but you can choose to collect one.`;

const FormSectionContainer = (): JSX.Element => {
  const { cookieEnabledServices, isTotalMonthlyPriceWithFeeEligible } = useSelector(
    (state) => ({
      cookieEnabledServices: state.app.cookieEnabledServices,
      isTotalMonthlyPriceWithFeeEligible: state.properties.currentProperty?.totalMonthlyPriceWithFeeNotice?.isEligible,
    }),
    shallowEqual,
  );

  const canAccessTotalMonthlyPriceWithFee = accessUtils.canAccessTotalMonthlyPriceWithFee({
    cookieEnabledServices,
    isEligible: isTotalMonthlyPriceWithFeeEligible,
  });

  return (
    <WizardFormSectionContainer data-testid="FormSectionContainer">
      <WizardHeading textStyle="heading-sm" level={1}>
        {canAccessTotalMonthlyPriceWithFee
          ? 'How much is the base rent and the security deposit?'
          : 'How much are the monthly rent and the security deposit?'}
      </WizardHeading>

      <WizardBody>{body}</WizardBody>

      <MonthlyRentFormField />

      <SecurityDepositFormField />

      <Box css={{ marginTop: '800' }}>
        <SpecialOffers />
      </Box>
    </WizardFormSectionContainer>
  );
};

export default FormSectionContainer;
